// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OfficesTableExplain_caption__97lwx {\n  border-top: 1px solid var(--border-table);\n}\n.OfficesTableExplain_caption__97lwx div {\n  font-style: italic;\n  color: rgba(220, 53, 69, 0.7);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Offices/OfficesTableExplain.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B","sourcesContent":[".caption {\n  border-top: 1px solid var(--border-table);\n}\n.caption div {\n  font-style: italic;\n  color: rgba(220, 53, 69, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"caption": "OfficesTableExplain_caption__97lwx"
};
export default ___CSS_LOADER_EXPORT___;
